import '../firebase/firebase'
import { notification, ConfigProvider } from 'antd'
import ReactGA from 'react-ga'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ThemeProvider } from 'styled-components'
import localeAntd from 'antd/locale/en_US'

import { theme, GlobalStyles } from '@styles'
import { Layout, LoginWithToken } from '@components'
import { GeneralProvider, UserProvider } from '@contexts'
import { config } from '@config'

import AppRoutes from './AppRoutes'
import { antdTheme } from '../styles/antd'

const trackingId = config.measurementId
ReactGA.initialize(trackingId!)

notification.config({
  placement: 'topRight',
  duration: 12,
})
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnMount: true,
      refetchOnReconnect: true,
      refetchOnWindowFocus: true,
    },
  },
})

const App = () => (
  <ThemeProvider theme={theme}>
    <ConfigProvider theme={antdTheme} locale={localeAntd}>
      <GlobalStyles />
      <QueryClientProvider client={queryClient}>
        <Layout>
          <UserProvider>
            <LoginWithToken>
              <GeneralProvider>
                <AppRoutes />
              </GeneralProvider>
            </LoginWithToken>
          </UserProvider>
        </Layout>
      </QueryClientProvider>
    </ConfigProvider>
  </ThemeProvider>
)

export { App }
